import LocationLayout from './LocationLayout';
import { P, H2b, UL, LI } from '../content/Typography';
import { locations } from './locations';

const meta = locations.find((l) => l.slug === 'metal-fabrication-mississauga');

export default function Mississauga() {
  return (
    <LocationLayout title={meta.title} description={meta.description} heading={meta.heading}>
      <H2b>Mississauga as a manufacturing hub</H2b>
      <P>
        Mississauga is one of the most concentrated manufacturing zones in the GTA, and its fabrication shops reflect that scale. The Dixie Road corridor is
        home to a dense cluster of machine shops and metal fabricators, many operating multiple shifts to keep up with industrial demand. Derry Road runs
        through a similar stretch of manufacturing and logistics facilities, while the Airport Corporate Centre — sitting directly next to Pearson — has
        attracted a tier of precision manufacturers that grew up alongside the aerospace and aviation supply chain based near the airport.
      </P>

      <H2b>Precision CNC and aerospace-grade work</H2b>
      <P>
        That proximity to aerospace supply chains has shaped what Mississauga shops are good at. A meaningful share of the city's fabrication capacity is
        built around precision CNC machining — tight-tolerance parts, documented material traceability, and process controls that meet the standards
        aerospace and defence buyers require. Even for clients outside those industries, this means Mississauga is a strong place to source a part when
        tolerance and repeatability matter more than speed or price.
      </P>

      <H2b>Industries served</H2b>
      <UL>
        <LI><strong>Aerospace-adjacent suppliers</strong> — precision components built to tight tolerances and documented material specs.</LI>
        <LI><strong>Automotive parts manufacturers</strong> — brackets, housings, and machined components for supply-chain production runs.</LI>
        <LI><strong>Industrial equipment manufacturers</strong> — custom machined and fabricated components for equipment built and serviced in the region.</LI>
        <LI><strong>Corporate and product teams</strong> — precision prototypes and low-volume production for companies headquartered in Mississauga's business parks.</LI>
      </UL>

      <H2b>Sourcing a Mississauga fabricator through MetalMatch</H2b>
      <P>
        Mississauga's shops are strong on precision, but that same specialization means not every shop is the right fit for every part — a job better suited
        to a Dixie Road CNC shop can end up quoted, slowly, by a generalist fabricator that is not really set up for it. Submit a sketch or photo of your
        part and MetalMatch matches you directly with fabricators in the Mississauga network whose equipment and tolerances fit what you are building,
        whether that is a single precision prototype or a production run destined for an aerospace or automotive supply chain.
      </P>
      <P>
        Shops in this network are also generally comfortable with the documentation that comes with precision work — material certificates, inspection
        reports, and traceable process records — so if your project needs that level of rigor, it is a standard expectation here rather than a special request.
      </P>
    </LocationLayout>
  );
}
